import { loaderSlice } from './slice';

export const { startPendingCall, stopPendingCall } = loaderSlice.actions;
